// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/TableOfContent/index.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/TableOfContent/index.tsx");
  import.meta.hot.lastModified = "1732036225879.2136";
}
// REMIX HMR END

import { useLocation } from "@remix-run/react";
import { TableOfContentItem } from "./TableIfContentItem";
import Heading from "../Heading";
export default function TableOfContent({
  links,
  activeSection
}) {
  _s();
  const {
    pathname
  } = useLocation();
  return <nav className="hidden lg:block">
      <Heading tag="h2">
        In this Article
      </Heading>
      <ul className="space-y-3 border-l border-neutral-300 relative">
        {links.map((component, index) => {
        if (!component) return;
        return <TableOfContentItem key={index} activeSection={activeSection || ""} index={index} pathname={pathname} title={component} />;
      })}
      </ul>
    </nav>;
}
_s(TableOfContent, "qVMqkCpYCjknUqSjfMln5RFSkbo=", false, function () {
  return [useLocation];
});
_c = TableOfContent;
var _c;
$RefreshReg$(_c, "TableOfContent");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;